import React from 'react';
import Logo from '../common/Logo/Logo';
import styles from './NavLogo.module.scss';

export function NavLogo() {
    return (
        <div className={styles.logo}>
            <Logo isWide={true} />
        </div>
    );
}
